export default __webpack_public_path__ + "static/react-native-app-development-company-peerbits-8c6febba359ef955fd47c39214a99167.png";